export * from './kunden-finanzen-gespeichert.interface';
